import React from 'react';

export function HeaderLogo({ logoURL, classList }) {
    return <img src={ logoURL } className={ classList } alt="Logo"/>;
}